<section class="u-align-center u-clearfix u-palette-2-light-3 u-section-1" id="sec-a0ee">
    <div class="u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xs u-clearfix u-sheet u-valign-middle-sm u-sheet-1">
        <div class="u-clearfix u-expanded-width u-layout-wrap sop-header-layout">
            <div class="u-layout">
                <div class="u-layout-col">
                    <div class="u-container-style u-layout-cell u-shape-rectangle u-size-30 u-layout-cell-1">
                        <div class="u-border-1 u-border-no-left u-border-no-right u-border-no-top u-border-palette-5-base u-container-layout u-container-layout-1 sop-header">
                            <h1 class="u-text u-text-default-lg u-text-default-md u-text-default-sm u-text-default-xs u-text-1">Deep Dive Workshops</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<loader *ngIf="loading"></loader>

<div *ngIf="!loading" class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card" style="width: 98%">
                    <div class="header" style="display: flex; justify-content: space-between;">
                        <div>
                            <h4 class="title">Deep Dive Workshops Services</h4>
<!--                            <p class="category">-->
<!--                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam, asperiores aspernatur atque autem consequatur cumque cupiditate delectus-->
<!--                            </p>-->
                        </div>
                        <button class="u-btn sop-btn" data-toggle="modal" data-target="#myModal" (click)="clearSelected()">Add service</button>
                    </div>
                    <div class="content table-responsive">
                        <div style="overflow-x: auto;">
                            <table class="table table-hover table-striped">
                                <thead>
<!--                                <tr>-->
<!--                                    <th *ngFor="let cell of headerRow">-->
<!--                                        <span *ngIf="sortSelected == cell && sortDirection == 'ASC'" (click)="sortCell(cell)">{{ cell }} <i style="color: #ec8b00; cursor: pointer;" onclick="sortCell(cell)" class="fa fa-arrow-up"></i></span>-->
<!--                                        <span *ngIf="sortSelected == cell && sortDirection == 'DESC'" (click)="sortCell(cell)">{{ cell }} <i style="color: #ec8b00; cursor: pointer;" class="fa fa-arrow-down"></i></span>-->
<!--                                        <span *ngIf="sortSelected != cell" (click)="sortCell(cell)">{{ cell }} <i style="cursor: pointer;" class="fa fa-arrow-up"></i></span>-->
<!--                                    </th>-->
<!--                                    <th>-->
<!--                                        ACTION-->
<!--                                    </th>-->
<!--                                </tr>-->
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Epes</th>
                                        <th>Services Status</th>
                                        <th>Effort</th>
                                        <th>Report</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let row of deepDives; let i = index;">
                                    <td>{{ i+1 }}</td>
                                    <td>{{ row['name'] }}</td>
                                    <td>{{ row['description'] }}</td>
                                    <td>
                                        <div class="selected-epe">
                                            <div *ngFor="let epe of getEpes(row['epes'])"
                                                 class="selected-table-epe-item"
                                                 style="background-color: #e0e0e0"
                                            >
<!--                                                 [ngClass]="{'pending-status': epe.status === 'PENDING', 'approved-status': epe.status === 'APPROVED', 'not-approved-status': epe.status === 'NOT_APPROVED'}"
                                            >
-->
                                                <span>{{ getEpeString(epe) }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ row['status'] }}</td>
                                    <td>{{ row['effort'] }}</td>
                                    <td>
                                        <div class="selected-epe">
                                            <div *ngFor="let report of row['report']"
                                                 class="selected-table-epe-item"
                                                 style="background-color: #e0e0e0">
                                                <a *ngIf="report.file !== ''" style="color: #ec8b00;" href="{{ downloadReport(report, row) }}"
                                                >{{ getReportString(report) }}</a>
                                                <p *ngIf="report.file === ''">{{ getReportString(report) }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="display: flex; justify-content: space-around;">
                                        <button *ngIf="row['status'] !== 'SUBMITTED'" class="u-btn sop-btn" style="margin-right: 10px;" data-toggle="modal" data-target="#myModal" (click)="openEditModal(row)">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button *ngIf="row['status'] === 'SUBMITTED'" class="u-btn sop-btn" style="margin-right: 10px;" data-toggle="modal" data-target="#myModal2" (click)="openEditModal(row, true)">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button class="u-btn danger-btn" (click)="alertConfirmation(row)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
<!--                                    <td>-->
<!--                                        <span style="color: #ec8b00; cursor: pointer;" (click)="openNewTab('/#/project/'+row['project_id'])">{{ row['Project'] }}</span>-->
<!--                                    </td>-->
<!--                                    <td><button (click)="goToDashboard(row['project_id'], row['epe_id'])" class="u-btn sop-btn">Go to all surveys</button></td>-->
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i style="color: #d9534f;" class="fa fa-times"></i>
                </button>
                <h4 class="modal-title">{{isEdit ? 'Edit' : 'Add'}} Service</h4>
            </div>
            <div class="modal-body">
                <form (ngSubmit)="onSubmit('SUBMITTED')" #serviceForm="ngForm">
                    <div class="form-group" style="margin: 0">
                        <label for="epe">Search Epe:</label>
                        <input id="epe" #epeSearchInput placeholder="Search Epe By Name" class="form-control" type="text" autocomplete="off" (click)="addListener()">
                    </div>

                    <!--  DropDown Starts  -->
                    <div *ngIf="showSearches" class="card">
                        <div class="search">
                            <div *ngFor="let epe of searchedEpes;" (click)="setEpe(epe)" class="search-result">
                                {{epe.name + ' ' + epe.surname + ' - ' + epe.email}}
                            </div>
                        </div>
                        <p class="search" *ngIf="searchedEpes && searchedEpes.length <= 0">No Epe found</p>
                    </div>

                    <!-- Epe selected list  -->
                    <div class="form-group" style="margin-top: 20px;">
                        <label for="epe">Selected Epe:</label>
                        <div class="selected-epe">
                            <div *ngFor="let epe of selectedEpes" class="selected-epe-item">
                                <span>{{epe.name + ' ' + epe.surname + ' - ' + epe.email}}</span>
                                <i (click)="removeEpe(epe)" class="fa fa-times"></i>
                            </div>
                            <div *ngIf="selectedEpes.length <= 0" class="selected-epe-item">
                                <span>No Epe selected</span>
                            </div>
                        </div>
                    </div>

                        <!-- Dropdown for Choices (CWA or HDD) -->
<!--                    <div class="form-group">-->
<!--                        <label for="serviceType">Service Type</label>-->
<!--                        <select class="form-control" id="serviceType" [(ngModel)]="selectedServiceType" name="selectedServiceType" required>-->
<!--                            <option value="CWA">CWA</option>-->
<!--                            <option value="DD">HYBRID DEEP DIVE SERIES</option>-->
<!--                        </select>-->
<!--                    </div>-->

                    <!-- Input fields for Service Name, Description, and Effort -->
                    <div class="form-group">
                        <label for="serviceName">Service Name</label>
                        <input type="text" class="form-control" id="serviceName" [(ngModel)]="serviceName" name="serviceName" required>
                    </div>

                    <div class="form-group">
                        <label for="description">Description</label>
                        <textarea class="form-control" id="description" [(ngModel)]="description" name="description" required></textarea>
                    </div>

                    <div class="form-group">
                        <label for="effort">Effort</label>
                        <input type="text" class="form-control" id="effort" [(ngModel)]="effort" name="effort" required>
                    </div>


                </form>
            </div>
            <div class="modal-footer" style="display: flex; justify-content: end;">
                <button type="button" class="u-btn danger-btn" data-dismiss="modal" style="margin-right: 10px;">Close</button>
                <button type="button" class="u-btn secondary-btn" data-dismiss="modal" style="margin-right: 10px;" (click)="onSubmit('DRAFT')"
                >Save as Draft</button>
                <button type="button" class="u-btn sop-btn" data-dismiss="modal"
                        [disabled]="!serviceForm.form.valid"
                        (click)="onSubmit('SUBMITTED')">Save & Submit
                </button>
            </div>
        </div>

    </div>
</div>

<div class="modal fade" id="myModal2" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i style="color: #d9534f;" class="fa fa-times"></i>
                </button>
                <h4 class="modal-title">Edit Effort Service</h4>
            </div>
            <div class="modal-body">
                <form (ngSubmit)="onSubmit('SUBMITTED')" #serviceForm="ngForm">
                    <div>
                        <h5>
                            Epes:
                        </h5>
                        <div class="selected-epe">
                            <div *ngFor="let epe of selectedEpes" class="selected-epe-item">
                                <span>{{epe.name + ' ' + epe.surname + ' - ' + epe.email}}</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h5>
                            Service Name:
                        </h5>
                        <p>
                            {{ serviceName }}
                        </p>
                    </div>
                    <div>
                        <h5>
                            Description:
                        </h5>
                        <p>
                            {{ description }}
                        </p>
                    </div>

                    <div class="form-group">
                        <label for="effort">Effort</label>
                        <input type="text" class="form-control" id="effort2" [(ngModel)]="effort" name="effort" required>
                    </div>

                </form>
            </div>
            <div class="modal-footer" style="display: flex; justify-content: end;">
                <button type="button" class="u-btn danger-btn" data-dismiss="modal" style="margin-right: 10px;">Close</button>
                <button type="button" class="u-btn sop-btn" data-dismiss="modal"
                        [disabled]="!serviceForm.form.valid"
                        (click)="onSubmit('SUBMITTED')">Submit
                </button>
            </div>
        </div>

    </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert" ></simple-alert>
